import { css } from '@emotion/core'

export const buttonContainer = css`
  text-align: center;
`

export const signupButton = css`
  width: 50%;
`
